<template>
  <section class="contact-page">
    <h2>联系我们</h2>
    <p>咨询、投诉、建议与合作，请使用以下联系方式。</p>
    <p v-if="loading" role="status">正在加载联系信息…</p>
    <div v-else-if="loadError" role="alert"><p>{{ loadError }}</p><button @click="loadContacts">重试</button></div>
    <p v-else-if="!contacts.length">暂无联系信息</p>
    <article v-for="item in contacts" :key="item.id" class="contact-row">
      <img :src="item.fileUrl" alt="" />
      <div class="contact-copy"><h3>{{ item.description }}</h3><p>{{ item.contactValue }}</p></div>
      <div class="contact-actions">
        <button v-if="item.showConsultButton === 1" @click="consult(item)">立即咨询</button>
        <button v-if="item.showCopyButton === 1" :aria-label="`复制${item.description}`" @click="copyContact(item)">复制</button>
      </div>
    </article>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { extensionApi } from '../api'

const emit = defineEmits(['navigate', 'notify'])
const contacts = ref([])
const loading = ref(false)
const loadError = ref('')

async function loadContacts() {
  if (loading.value) return
  loading.value = true
  loadError.value = ''
  try {
    const result = await extensionApi.appConfig()
    if (!Array.isArray(result.contacts)) throw new Error('联系信息返回格式异常')
    contacts.value = result.contacts
  } catch (error) {
    contacts.value = []
    loadError.value = error.message || '联系信息加载失败'
  } finally { loading.value = false }
}
onMounted(loadContacts)

async function copyContact(item) {
  try {
    await navigator.clipboard.writeText(item.contactValue)
    emit('notify', '复制成功')
  } catch (_) { emit('notify', '复制失败，请重试') }
}

function consult(item) {
  const target = String(item.jumpLink || '').trim().replace(/^\/#(?=\/pages\/)/, '')
  if (!target || target === '/pages/customer/index') return emit('navigate', '/customer/main')
  if (target.startsWith('/') && !target.startsWith('//') && !target.startsWith('/pages/')) return emit('navigate', target)
  try {
    const address = new URL(target)
    if (/^https?:$/.test(address.protocol)) { window.location.href = address.href; return }
  } catch (_) {}
  emit('notify', '咨询链接暂时无法打开')
}
</script>

<style scoped>
.contact-page { padding: 28px; border-radius: 12px; background: #fff; }
.contact-page > p { color: #747e91; }
.contact-row { display: flex; align-items: center; gap: 20px; padding: 22px 0; border-bottom: 1px solid #edf0f5; }
.contact-row > img { width: 64px; height: 64px; object-fit: contain; }
.contact-copy { flex: 1; min-width: 0; }
.contact-copy h3 { margin: 0 0 10px; font-size: 16px; }
.contact-copy p { margin: 0; overflow-wrap: anywhere; }
.contact-actions { display: flex; gap: 10px; }
button { padding: 8px 16px; border: 1px solid #dce5ee; border-radius: 6px; color: #1a3f6e; background: #edf3fa; cursor: pointer; }
@media (max-width: 640px) { .contact-row { flex-wrap: wrap; } .contact-actions { width: 100%; } }
</style>
